<template>
  <v-dialog persistent v-model="app.actiovationKeyDialog" width="30%">
    <v-card :loading="app.actiovationKeyLoading">
      <v-card-title class="headline grey lighten-2" primary-title>
        {{$t('app.sysinfo')}}
        <v-spacer></v-spacer>
        <v-icon v-if="app.isOfflineLicense">mdi-cloud-off-outline</v-icon>
        <v-icon v-if="!app.isOfflineLicense && !isConcurrentLicense">mdi-cloud-check-outline</v-icon>
        <v-icon v-if="!app.isOfflineLicense && isConcurrentLicense">mdi-repeat-once</v-icon>
      </v-card-title>
      <v-card-text v-show="app.IsMFilesLicense">
        <br/>
        <p v-show="app.licenseStatusCode === 0 && app.licenseTrial">{{ 'License: TRIAL' }}</p>
        <p>{{ $t('app.licencestatus') + app.MFilesLicenseStatus }}</p>
      </v-card-text>
      <v-card-text v-show="!offlineRequest && !offlineDeactivationRequest && !app.IsMFilesLicense">
        <br/>
        <p v-show="app.licenseStatusCode === 0 && app.licenseTrial">{{ 'License: TRIAL' }}</p>
        <p>{{ $t('app.licencestatus') + app.licenseStatus }}</p>
        <p v-show="app.licenseExpireDate.indexOf('1970') < 0 && app.licenseExpireDate !== ''">{{ $t('app.licencedate') + app.licenseExpireDate }}</p>
        <p v-if="app.licenseStatusCode !== 0">{{$t('app.licenceactivate')}}</p>
        <v-form ref="formKeyActive">
          <!-- <v-text-field clearable v-model="softwareKey" :disabled="licenseStatusCode === 0" :rules="[() => !!softwareKey || $t('app.licencekeyrule')]" required validate-on-blur></v-text-field> -->
          <v-text-field clearable v-model="app.softwareKey" v-show="app.licenseStatusCode === 0 && !app.licenseTrial" :disabled="app.licenseStatusCode === 0 && !app.licenseTrial" :rules="[]" :required="app.licenseStatusCode === 0 && app.softwareKey === ''" validate-on-blur></v-text-field>
          <v-text-field clearable v-model="app.softwareKey" v-show="app.licenseStatusCode === 0 && app.licenseTrial" :rules="[() => !!app.softwareKey || $t('app.licencekeyrule')]" :required="app.licenseStatusCode === 0 && app.softwareKey === ''" validate-on-blur></v-text-field>
          <v-text-field clearable v-model="app.softwareKey" v-show="app.licenseStatusCode !== 0"></v-text-field>
          <v-progress-linear :active="app.actiovationKeyLoading" :background-opacity=".5" :indeterminate="app.actiovationKeyLoading" :rounded="true" :stream="true" color="light-blue"></v-progress-linear>
        </v-form>
      </v-card-text>
      <v-divider v-show="!offlineRequest && !offlineDeactivationRequest && !app.IsMFilesLicense"></v-divider>
      <v-card-actions v-show="!offlineRequest && !offlineDeactivationRequest && !app.IsMFilesLicense">
        <v-spacer></v-spacer>
        <v-btn v-if="app.licenseStatusCode !== 0 && app.softwareKey !== '' && app.softwareKey !== null" color="black" text @click="activateKeyProduct(false, true)">{{$t('app.licenceactiveOffline')}}</v-btn>
        <v-btn v-if="app.licenseStatusCode !== 0 && app.softwareKey !== '' && app.softwareKey !== null" color="warning" text @click="activateKeyProduct()">{{$t('app.licenceactive')}}</v-btn>
        <v-btn v-if="app.licenseStatusCode !== 0 && app.softwareKey === '' || app.softwareKey === null" color="warning" text @click="activateKeyProduct(true)">{{$t('app.licenceactivetrial')}}</v-btn>
        <v-btn v-if="app.licenseStatusCode === 0 && app.licenseTrial" color="black" text @click="activateKeyProduct(false, true)">{{$t('app.licenceactiveOffline')}}</v-btn>
        <v-btn v-if="app.licenseStatusCode === 0 && app.licenseTrial" color="warning" text @click="activateKeyProduct()">{{$t('app.licenceactive')}}</v-btn>
        <v-btn v-if="app.licenseStatusCode === 0 && !app.licenseTrial && app.isOfflineLicense" color="black" text @click="deactivateKeyProduct(true)">{{ $t('app.licencedeactivateOffline') }}</v-btn>
        <v-btn v-if="app.licenseStatusCode === 0 && !app.licenseTrial && !app.isOfflineLicense" color="warning" text @click="deactivateKeyProduct()">{{$t('app.licencedeactivate')}}</v-btn>
        <v-btn v-if="app.licenseStatusCode === 0" color="primary" text @click="app.actiovationKeyDialog = false">{{$t('app.licencecancel')}}</v-btn>
      </v-card-actions>
      <!-- ACTIVATION -->
      <v-card-text v-if="offlineRequest && !app.IsMFilesLicense">
        <br/>
        <p v-html="$t('app.licenseOfflineInstruction')"></p>
        <v-form ref="formRequest">
          <input ref="licenseFile" type="file" id="fileInput" accept=".license" style="display: none;"/>
          <v-textarea outlined :label="$t('app.licenceOfflineRequestActivation')" :value="OfflineRequestDataValue"></v-textarea>
        </v-form>
      </v-card-text>
      <v-divider v-show="offlineRequest && !app.IsMFilesLicense"></v-divider>
      <v-card-actions v-show="offlineRequest && !app.IsMFilesLicense">
        <v-btn text @click="copyRequestActivation">{{ $t('app.licenceCopyToClipboard') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="warning" text @click="onClickLoadFile">{{ $t('app.licenceLoadFile') }}</v-btn>
      </v-card-actions>
      <!-- DEACTIVATION -->
      <v-card-text v-if="offlineDeactivationRequest && !app.IsMFilesLicense">
        <br/>
        <p v-html="$t('app.licenseOfflineDeactivationInstruction')"></p>
        <v-form ref="formRequest">
          <!-- <input ref="licenseFile" type="file" id="fileInput" accept=".license" style="display: none;"/> -->
          <v-textarea outlined :label="$t('app.licenceOfflineRequestDeactivation')" :value="OfflineRequestDeactivationDataValue"></v-textarea>
        </v-form>
      </v-card-text>
      <v-divider v-show="offlineDeactivationRequest && !app.IsMFilesLicense"></v-divider>
      <v-card-actions v-show="offlineDeactivationRequest && !app.IsMFilesLicense">
        <v-btn text @click="copyRequestDeactivation">{{ $t('app.licenceCopyToClipboard') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="warning" text @click="closeOfflineDeactivation">{{ $t('app.licenceDialogClose') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Models from '@/Models'
import { copyToClipboard } from '../clipboard'
export default {
  name: 'ActivationDialog',
  emits: ['activate', 'deactivate'],
  props: {
    app: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      deactivateKey: '',
      offlineRequest: false,
      offlineRequestData: '',
      offlineDeactivationRequest: false,
      offlineRequestDeactivationData: ''
    }
  },
  computed: {
    isConcurrentLicense () {
      return this.app.licenseType === 'hosted-floating'
    },
    OfflineRequestDataValue () {
      const data = this.offlineRequestData
      return `**** Activation request ****
Serial Number: [${this.app.softwareKey}]
Request Code: [${data}]`
    },
    OfflineRequestDeactivationDataValue () {
      const data = this.offlineRequestDeactivationData
      return `**** Deactivation request ****
Serial Number: [${this.deactivateKey}]
Request Code: [${data}]`
    }
  },
  methods: {
    copyRequestActivation () {
      copyToClipboard(this.OfflineRequestDataValue)
    },
    copyRequestDeactivation () {
      copyToClipboard(this.OfflineRequestDeactivationDataValue)
    },
    closeOfflineDeactivation () {
      this.app.softwareKey = ''
      this.offlineDeactivationRequest = false
      this.deactivateKey = ''
    },
    deactivateKeyProduct (offline = false) {
      console.log('deactivateKeyProduct()')
      if (!this.$refs.formKeyActive.validate()) return
      this.app.actiovationKeyLoading = true
      const action = Models.Action
      action.TYPE = Models.ActionType.DEACTIVATION
      action.Data = this.app.softwareKey
      action.Offline = offline
      action.OfflineResponseDeactivationData = (offline) ? 'COMPLETE' : ''
      this.app.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.DEACTIVATION)
    },
    activateKeyProduct (isTrial = false, offline = false) {
      console.log('activateKeyProduct() trial:' + isTrial)
      if (!this.$refs.formKeyActive.validate()) {
        if (!isTrial) return
      }
      this.app.actiovationKeyLoading = true
      const action = Models.Action
      action.TYPE = Models.ActionType.ACTIVATION
      action.Data = this.app.softwareKey
      action.Offline = offline
      this.app.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.ACTIVATION)
    },
    onClickLoadFile () {
      this.addSelectListener()
      this.$refs.licenseFile.click()
    },
    addSelectListener () {
      console.log(this.$refs.licenseFile)
      this.$refs.licenseFile.addEventListener('change', this.onSelectFile)
    },
    removeListener () {
      this.$refs.licenseFile.removeEventListener('change', this.onSelectFile)
    },
    onSelectFile (e) {
      console.log('onSelectFile', e)
      const selectedFile = e.target.files[0]
      const reader = new FileReader()
      reader.onload = (event) => {
        console.log('onSelectFile loaded... activate offline license')
        const fileContent = event.target.result
        // console.log(fileContent, event, 'Result:', reader.result)
        this.app.actiovationKeyLoading = true
        const action = Models.Action
        action.TYPE = Models.ActionType.ACTIVATION
        action.Data = this.app.softwareKey
        action.OfflineResponseData = fileContent
        action.Offline = true
        this.app.ws._send(JSON.stringify(action))
        this.$swsa.emitClick(Models.ActionType.ACTIVATION)
        this.removeListener()
      }
      reader.readAsText(selectedFile, 'utf-8')
    }
  },
  mounted () {
  }
}
</script>
